import React, { ComponentType } from 'react';
import usePageClassName from '../hooks/usePageClassName';

type Props = {
  page: ComponentType;
};

const ExtraPage: React.FC<Props> = ({ page }) => {
  usePageClassName('generic-page');
  const Page = page;
  return <Page />;
};

export default ExtraPage;
